<template>
  <div id="app" class="container">
    <div class="studentCourse">
      <SemesterSelector :semesterId="semesterId"></SemesterSelector>
      <el-date-picker style="width: 100%;" v-model="date" type="date" placeholder="Select date" clearable @change="getAttendance"></el-date-picker>
    </div>
    <div class="classInfo">
      <el-card v-for="item in attendance" :key="item.id" class="card-panel">
        <!-- eslint-disable-next-line -->
        <div slot="header" style="padding-bottom: 10px;">
          <span class="class-title">{{ formatDate(item.date, 'title') }}</span>
          <span class="class-item" :style="{ color: getColor(item.status), float: 'right' }">{{ item.status }}</span>
        </div>
        <div style="padding-bottom: 10px; display: inline-block;">
          <p class="class-item">{{ item.courseName }}</p>
          <p class="class-item">student: {{ item.studentName }}</p>
          <p v-if="item.reason" class="class-item">reason: {{ item.reason }}</p>
          <p v-if="item.updatedAt" class="class-item">updated at: {{ item.updatedAt }}</p>
        </div>
        <el-button type="primary" style="float: right;" size="small"
          v-if="item.status == 'INITIAL' || item.status == 'ABSENT'" @click="requestLeave(item)">request leave
        </el-button>
      </el-card>
      <div v-if="attendance.length==0" align="center">暂无数据</div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { BACKEND_URL } from '../../../share-source/src/config/config.js'
import SemesterSelector from "../components/SemesterSelector.vue";  
import { AttendanceStatus } from "../constants/AttendanceStatus.js";

export default {
  name: "MyAttendance",
  watch: {
    // 'date': {
    //   handler(newDate) {
    //     console.log("newDate", newDate);
    //     this.getAttendance();
    //     // this.$router.push({ name: 'MyAttendance', params: { student_id: this.student_id, date: newDate } });
    //   }
    // },
    // 'student_id': {
    //   handler(newStudentId) {
    //     console.log("newStudentId", newStudentId);
    //     this.getAttendance();
    //   }
    // },
    // '$route': {
    //   handler(newRoute) {
    //     if (newRoute.name !== 'MyAttendance') {
    //       return;
    //     }

    //     this.student_id = newRoute.params.student_id;
    //     this.date = newRoute.params.date;
    //     this.getAttendance();
    //   }
    // } 
  },
  data() {
    return {
      student_id: this.$route.params.student_id,
      attendance: [],
      semesterId: '',
      date: this.$route.params.date || null
    };
  },
  components: {
    SemesterSelector
  },
  mounted() {
    // document.title = "my courses to attend";
    this.getAttendance();
  },
  methods: {
    requestLeave(item) {
      this.$prompt('Please enter leave reason', 'Request Leave', {
        confirmButtonText: 'Submit',
        cancelButtonText: 'Cancel',
        inputPattern: /\S+/,
        inputErrorMessage: 'Reason cannot be empty'
      }).then(({ value }) => {
        const params = new URLSearchParams();
        params.append('attendanceId', item.id);
        params.append('reason', value);

        axios.post(BACKEND_URL + "/api/attendance/leave", params).then(() => {
          this.$message({
            type: 'success',
            message: 'Leave request submitted successfully'
          });
          this.getAttendance();
        }).catch(error => {
          this.$message.error('Failed to submit leave request: ' + error.message);
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Request cancelled'
        });
      });
    },
    getColor(status) {
      return AttendanceStatus.getColor(status);
    },
    getAttendance() {
      const that = this;
      const params = new URLSearchParams();
      if (this.date !== null && this.date !== '') {
        const startDate = new Date(this.date);
        startDate.setHours(0, 0, 0, 0);
        const endDate = new Date(startDate);
        endDate.setDate(endDate.getDate() + 1);
        params.append('startDate', startDate.toISOString());
        params.append('endDate', endDate.toISOString());
      }
      axios
        .get(BACKEND_URL + "/api/attendance/student/" + this.student_id, { params })
        .then(function(rsp) {
          that.attendance = rsp.data.sort((a, b) => new Date(b.date) - new Date(a.date));
          if (rsp.data.length > 0) {
            that.semesterId = rsp.data[0].semesterId;
          }
        })
        .catch(function(error) {
          console.error('Error fetching attendance:', error);
        });
    },
    formatDate: function(date, format) {
      if (!date) return '';
      if (!format) format = "yyyy-MM-dd HH:mm:ss";
      
      let dateObj;
      try {
        // Handle string dates
        if (typeof date === "string") {
          // Try parsing ISO format first
          dateObj = new Date(date);
          // If invalid, try with slash replacement
          if (isNaN(dateObj.getTime())) {
            dateObj = new Date(date.replace(/-/g, "/"));
          }
        } else if (typeof date === "number") {
          dateObj = new Date(date);
        } else if (date instanceof Date) {
          dateObj = date;
        } else {
          return '';
        }

        // Final validation
        if (isNaN(dateObj.getTime())) {
          console.warn('Invalid date:', date);
          return '';
        }

        // For title display, use a simpler format
        if (format === "title") {
          return dateObj.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
          });
        }

        const dict = {
          yyyy: dateObj.getFullYear(),
          M: dateObj.getMonth() + 1,
          d: dateObj.getDate(),
          H: dateObj.getHours(),
          m: dateObj.getMinutes(),
          s: dateObj.getSeconds(),
          MM: String(dateObj.getMonth() + 1).padStart(2, '0'),
          dd: String(dateObj.getDate()).padStart(2, '0'),
          HH: String(dateObj.getHours()).padStart(2, '0'),
          mm: String(dateObj.getMinutes()).padStart(2, '0'),
          ss: String(dateObj.getSeconds()).padStart(2, '0')
        };

        return format.replace(/(yyyy|MM?|dd?|HH?|ss?|mm?)/g, function() {
          return dict[arguments[0]] || '';
        });
      } catch (error) {
        console.error('Date formatting error:', error, 'for date:', date);
        return '';
      }
    },
  }
};
</script>

<style>
.container {
  display: flex;
  flex-direction: column;
  /* overflow: hidden; */
}

.studentCourse {
  background-color: #f2f3f7;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #e8eaec;
  padding-bottom: 8px;
}

.studentCourse .select-panel {
  /* width: 98%; */
  /* margin-left: 1%; */
  display: flex;
  position: relative;
  flex: 1;
}

.studentCourse .term-select {
  /* width: 100%; */
  background-color: #ffffff;
  height: 36px;
  line-height: 32px;
  border-radius: 5px;
  color: #343434;
  font-size: 14px;
  padding: 3px 14px;
  display: flex;
  align-items: center;
  flex: 1;
}
.studentCourse .open-select {
  background: url("../assets/images/go-item.png") no-repeat center center;
  background-size: 7px;
  width: 20px;
  height: 20px;
  position: absolute;
  right: 10px;
  top: 8px;
}
.classInfo {
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: auto;
}
.card-panel {
  padding: 5px 10px;
  border: 1px solid #8ACF55;
  box-shadow: 0px 0px 5px #8ACF55;
  border-radius: 5px;
  /* width: 92%; */
  margin: 6px;
  overflow: visible !important;
  /* height: 300px; */
}

.class-title {
  color: #7a7a7a;
  font-size: 16px;
  font-weight: bold;
  margin: 5px 0 10px 0;
}
.class-item {
  font-size: 14px;
  line-height: 20px;
  color: #b1b2ba;
  margin: 0;
}
.ivu-card-body {
  padding: 8px;
}
.ivu-card-head {
  border-bottom: 1px solid #e8eaec;
  padding: 5px 8px;
  line-height: 1;
}

.el-card {
  padding: 4px;
}

</style>
